<!-- eslint-disable indent -->
<template>
  <div class="main" v-cloak>
    <div class="category-swiper">
      <div class="category" ref="category">
        <div class="category-ul" :style="{ background: navBack }">
          <div class="category-li" v-for="(item, index) in categoryData" :style="{'--hover-color':pc_hover_color}">
            <span :style="{color:pc_font_color}">{{ item.name }}</span>
            <div class="icon-r">
              <i :style="{color:pc_font_color}" class="el-icon-arrow-right"></i>
            </div>

            <div class="category-info">
              <div class="info-ul">
                <div class="info-li" v-for="(item, index) in item.child" @click="categoryClick(item)">
                  <div class="icon">
                    <img :src="item.pic" alt="" />
                  </div>
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper" ref="swiper">
        <el-carousel :interval="5000" :height="`${swiperHeight}px`" ref="carousel" @click.native="paycodeTap()">
          <el-carousel-item v-for="(item, index) in swiperData" :key="index">
            <img :src="item.imgurl" class="slide-image" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="category-list">
      <div class="lis" v-for="(item, index) in categorystList" @click="categorystListClick(item)">
        <div class="icon-t">
          <img :src="item.imgurl" alt="" />
        </div>
        <span>{{ item.text }}</span>
      </div>
    </div>

    <div class="jztj" v-for="(item,index) in floorData">
      <div class="jztj-title">
        <span>{{item.name}}</span>
        <span @click="floorClick(item)">更多<i class="el-icon-arrow-right"></i>
        </span>
      </div>
      <div class="shop-list">
        <div class="shop-li" v-for="(items, indexs) in item.product" @click="shopDetailTap(items)">
          <div class="logo">
            <img :src="items.pic" alt="" />
          </div>
          <div class="shop-text">
            <div class="name">
              {{items.name}}
            </div>

            <div class="price-prve-xl">
              <div class="l-cont">
                <div class="price">
                  ￥{{items.sell_price||0}}
                </div>
                <div class="hxj">
                  ￥{{ items.market_price||0 }}
                </div>
              </div>
              <div class="xl-gm">
                {{items.sales||0}}人购买
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- title="提示" -->
    <!-- title="1" align="center" -->
    <el-dialog width="1000px" :visible.sync="dialogVisible" :before-close="handleClose" top="5.5vh">
      <div class="dialog-footer">
        <div class="code-logo">
          <img :src="dialogLogoSrc" alt="" />
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        categorystList: [],
        swiperData: [],
        categoryData: [],
        floorData: [],
        navBack: "",
        swiperHeight: 0,
        pc_font_color: "#FFFFFF",
        pc_hover_color: "#FF6700",
        dialogVisible: false,
        dialogLogoSrc: "",
      }
    },

    // 获取轮播图
    // https://pen.loojj.com/?s=/apiPc.Index/getBanner
    // 获取栏目
    // https://pen.loojj.com/?s=/apiPc.Index/getMenu
    mounted() {
      this.getcategory() //分类接口

      this.getMenus() //获取栏目

      this.getBanner(); //获取轮播图

      this.getConfig(); //获取背景颜色

      this.getFloor(); //获取底部商品列表
    },
    methods: {
      paycodeTap() {
        let item = this.swiperData[this.$refs.carousel.activeIndex];
        console.log(item)
        if (item.pop_image) {
          this.dialogVisible = true;
          this.dialogLogoSrc = item.pop_image
        }
      },
      handleClose(done) {
        done();
      },
      floorClick(item) {
        this.$router.push({
          path: "/pages/shop/prolist",
          query: {
            cid: item.id,
            name: item.name,
          }
        })
      },
      shopDetailTap(items) {
        this.$router.push({
          path: "/pages/shop/shopDetails",
          query: {
            id: items.id,
          }
        })
      },
      getFloor() {
        this.$http.post('?s=/apiPc.Index/getFloor')
          .then(response => {
            this.floorData = response.data;
          })
          .catch(error => {});
      },
      getConfig() {
        this.$http.post('?s=/apiPc.Index/config')
          .then(response => {
            let configObj = response.data.sysset;
            this.navBack = configObj.pc_theme_color ? configObj.pc_theme_color : "";
            this.pc_font_color = configObj.pc_font_color ? configObj.pc_font_color : "";
            this.pc_hover_color = configObj.pc_hover_color ? configObj.pc_hover_color : "";


            document.title = configObj.pc_title;

            this.dialogLogoSrc = configObj.pc_poster_image ? configObj.pc_poster_image : ""; //共用dialong
            var isIndexLogo = localStorage.getItem("isIndexLogo") ? localStorage.getItem("isIndexLogo") :
              false; //是否为第一次打开 false是 true否
            if (this.dialogLogoSrc && Boolean(!isIndexLogo)) {
              this.dialogVisible = true;
              localStorage.setItem("isIndexLogo", true)
            }
          })
          .catch(error => {});
      },
      categorystListClick(item) {
        this.$router.push({
          path: item.hrefurl,
          query: {
            name: item.text
          }
        })
      },
      getBanner() { // 获取轮播图
        this.$http.post('?s=/apiPc.Index/getBanner')
          .then(response => {
            this.swiperData = response.data;
          })
          .catch(error => {});
      },
      getMenus() { // 获取栏目
        this.$http.post('?s=/apiPc.Index/getMenu')
          .then(response => {
            this.categorystList = response.data;
          })
          .catch(error => {});
      },
      categoryClick(item) {
        this.$router.push({
          path: "/pages/shop/prolist",
          query: {
            cid: item.id,
            name: item.name,
          }
        })
      },
      getcategory() {
        this.$http.post('?s=/apiPc.Product/category')
          .then(response => {
            this.categoryData = response.data;
            if (this.categoryData && this.categoryData.length) {
              setTimeout(() => {
                this.swiperHeight = this.$refs.category.getBoundingClientRect().height; //获取轮播图宽度 计算出轮播图高度
              }, 50)
            }
          })
          .catch(error => {});
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    padding: 0 123px 20px 123px;
    background: #f5f5f5;
  }

  .main .dialog-footer .code-logo {
    width: 800px;
    height: 400px;
    margin: 0 auto;
    padding-bottom: 30px;
  }

  .main .jztj .jztj-title {
    padding-left: 1%;
    padding-top: 30px;
    /* padding-bottom: 10px; */
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .main .jztj .jztj-title span {
    font-size: 20px;
    font-weight: bold;
    line-height: 44px;
    padding-right: 1%;
    user-select: none;
    cursor: pointer;
  }

  .main .jztj .jztj-title span:last-child {
    font-size: 16px;
    font-weight: normal;
  }

  .main .shop-list {
    display: flex;
    flex-wrap: wrap;
  }

  .main .shop-list .shop-li {
    width: 18%;
    margin: 15px 1% 0 1%;
    background: #FFFFFF;
    /* min-height: 320px; */
    cursor: pointer;
  }

  .main .shop-list .shop-li .logo {
    width: 100%;
    /* height: 256px; */
  }

  .main .shop-list .shop-li .shop-text {
    padding: 12px;
  }

  .main .shop-list .shop-li .shop-text .name {
    font-size: 16px;
    line-height: 24px;
    height: 50px;
    display: -webkit-box;
    overflow: hidden;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /*显示的行数*/
  }

  .main .shop-list .shop-li .shop-text .price-prve-xl {
    display: flex;
    align-items: center;
    justify-content: space-between;

  }

  .main .shop-list .shop-li .shop-text .price-prve-xl .l-cont {
    display: flex;
    align-items: flex-end;
  }

  .main .shop-list .shop-li .shop-text .price-prve-xl .xl-gm {
    font-size: 12px;
    color: #888888;
    line-height: 30px;
  }

  .main .shop-list .shop-li .shop-text .price-prve-xl .price {
    font-size: 18px;
    color: red;
    line-height: 34px;
    font-weight: bold;
  }

  .main .shop-list .shop-li .shop-text .price-prve-xl .hxj {
    font-size: 14px;
    color: #888888;
    line-height: 30px;
    text-decoration: line-through;
    margin-left: 5px;
  }

  .category-list {
    display: flex;
    padding: 20px 0 0 0;
    flex-wrap: wrap;
    width: calc(100% + 5.714%);
    transform: translateX(-2.857%);
  }

  .category-list .lis {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 2.857% 20px 0;
    cursor: pointer;
    user-select: none;
    width: 10%;
  }

  .category-list .lis:nth-child(8n) {
    margin-right: 0;
  }

  .category-list .lis .icon-t {
    width: 50px;
    /* height: 50px; */
  }

  .category-list .lis span {
    font-size: 18px;
    line-height: 44px;
  }

  .category-list .lis:hover span {
    color: #FF6700;
  }

  .category-swiper {
    padding: 0 0 15px 0;
    display: flex;
  }

  .category-swiper .swiper {
    flex: 1;
    padding-left: 12px;
    cursor: pointer;
  }

  .category-swiper .category {
    display: flex;
  }

  .category-swiper .category .category-info {
    width: 999px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 100%;
    background: #FFFFFF;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
    display: none;
    z-index: 9999;
  }

  .category-swiper .category .category-info .info-ul {
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;
  }

  .category-swiper .category .category-info .info-ul .info-li {
    display: flex;
    align-items: center;
    width: 33.33%;
    margin: 10px 0;
    cursor: pointer;
    user-select: none;
  }

  .category-swiper .category .category-info .info-ul .info-li .icon {
    width: 45px;
    /* height: 45px; */
    display: inline-block;
    margin-left: 100px;
  }

  .category-swiper .category .category-info .info-ul .info-li span {
    font-size: 14px;
    color: #000000;
    display: inline-block;
    line-height: 54px;
    /* line-height: 20px;
    height: 20px; */
  }

  .category-swiper .category .category-info .info-ul .info-li:hover span {
    color: #FF6700;
  }

  .category-swiper .category .category-ul {
    /* background: #666666; */
    padding: 10px 0;
    position: relative;
    box-sizing: content-box;
    /* width: 234px; */
  }

  .category-swiper .category .category-ul .category-li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    user-select: none;
  }

  .category-swiper .category .category-ul .category-li:hover {
    /* background: #FF6700; */
    background-color: var(--hover-color);
  }

  .category-swiper .category .category-ul .category-li:hover .category-info {
    display: block;
  }

  .category-swiper .category .category-ul .category-li span {
    /* color: #FFFFFF; */
    font-size: 14px;
    line-height: 42px;
    display: inline-block;
    padding: 0 10px 0 30px;

  }

  .category-swiper .category .category-ul .category-li .icon-r {
    margin-right: 26px;
  }
</style>



// WEBPACK FOOTER //
// src/views/pages/index/index.vue